import { combineReducers } from "redux";
import { productReducer } from "./Product.Reducer";
import { cartReducer } from "./Cart.Reducer";
import { authReducer } from "./Auth.Reducer";
import {
  inventoryReducer,
  utilitiesReducer,
  restaurantReducer,
  customerReducer,
  accountReducer,
  SalesPurchaseReducer,
  BookingReducer,
  DashboardReducer,
  StockReducer, 
} from "./Modules.Reducer";
import { socketReducer } from "./Socket.Reducer";

const reducers = combineReducers({
  Products: productReducer,
  Cart: cartReducer,
  Auth: authReducer,
  Inventory: inventoryReducer,
  Utilities: utilitiesReducer,
  Restaurant: restaurantReducer,
  Customer: customerReducer,
  Accounts: accountReducer,
  SalesPurchase: SalesPurchaseReducer,
  Booking: BookingReducer,
  Dashboard: DashboardReducer,
  Stock: StockReducer,
  Socket: socketReducer,
});

export default reducers;
